import { type TranslationTree } from '@/i18n/types';

export const messages = {
  emailRequired: 'E-mail é obrigatório',
  emailInvalid: 'Por favor, insira um e-mail válido',
  passwordRequired: 'Senha é obrigatória',
  firstNameRequired: 'Nome é obrigatório',
  passwordMismatch: 'As senhas não coincidem',
  confirmPasswordRequired: 'Confirmação de senha é obrigatória',
  privacyRequired: 'Você deve aceitar a Política de Privacidade para continuar',
  emailRequiredAlt: 'O e-mail é obrigatório',
  emailInvalidShort: 'E-mail inválido',
  tokenRequired: 'Token é obrigatório',
} satisfies TranslationTree;
